import * as real from "src/pages/study/overview/overview.service"
import * as mock from "src/pages/study/overview/overview.mock"
import { selectService } from "@myvp/shared/src/functions/mock"
import { roundCompliance } from "src/pages/study/functions/format-compliance"

const service =
  process.env.REACT_APP_release === "true"
    ? real
    : selectService({ mock, real })
export const getStudyHomeMetrics = async (globalSponsorStudyId: string) => {
  const result = await service.getStudyHomeMetrics(globalSponsorStudyId)

  const rounded = {
    ...result,
    sponsorStudyMetrics: {
      ...result.sponsorStudyMetrics,
      eproCompliance:
        typeof result.sponsorStudyMetrics.eproCompliance === "number"
          ? roundCompliance(result.sponsorStudyMetrics.eproCompliance)
          : result.sponsorStudyMetrics.eproCompliance,
      eclinroCompliance:
        typeof result.sponsorStudyMetrics.eclinroCompliance === "number"
          ? roundCompliance(result.sponsorStudyMetrics.eclinroCompliance)
          : result.sponsorStudyMetrics.eclinroCompliance,
    },
    eproSiteMetrics: result.eproSiteMetrics.map((m) => ({
      ...m,
      completedSurveysPercent:
        typeof m.completedSurveysPercent === "number"
          ? roundCompliance(m.completedSurveysPercent)
          : m.completedSurveysPercent,
    })),
    eclinroSiteMetrics: result.eclinroSiteMetrics.map((m) => ({
      ...m,
      completedSurveysPercent:
        typeof m.completedSurveysPercent === "number"
          ? roundCompliance(m.completedSurveysPercent)
          : m.completedSurveysPercent,
    })),
    siteSignatureMetrics: result.siteSignatureMetrics.map((m) => ({
      ...m,
      percentParticipantsWithSignaturesComplete:
        typeof m.percentParticipantsWithSignaturesComplete === "number"
          ? roundCompliance(m.percentParticipantsWithSignaturesComplete)
          : m.percentParticipantsWithSignaturesComplete,
    })),
  }

  const hasNeitherEproNorEclinro =
    !rounded.sponsorStudyMetrics.hasEpro &&
    !rounded.sponsorStudyMetrics.hasEclinro
  if (hasNeitherEproNorEclinro) {
    return {
      ...rounded,
      sponsorStudyMetrics: {
        ...rounded.sponsorStudyMetrics,
        hasEpro: true,
        hasEclinro: true,
      },
    }
  }
  return rounded
}
